/**
 * @todo: this appears to be something that should be global
 */
export const allowedDomains = [
  typeof window && window.location.host,
  "https://staging.smartrr.com",
  "https://app.staging.smartrr.com",
  "https://www.smartrr.com",
  "https://smartrr.com",
  "https://app.smartrr.com",
  "https://www.app.smartrr.com",
].filter(Boolean);
